import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import FlexView from "react-flexview";
import DataGrid from "../../../../../../shared/components/Grid";
import {exportGrid, initialColsSelector, onChangeColumns} from "../../../../../../shared/components/Grid/functions";
import { resetFilters } from "../../../../../../shared/components/Grid/functions/filters";
import { getColumnDefs } from "./columnDefs";

export interface Props {
  data: any;
  style?: any;
  menu: boolean;
  selector: boolean;
  ref: any;
}

export const GridResultsScreen = forwardRef((props:Props, ref:any) => {

  let { data, style, menu, selector } = props;
  let columnDefs = getColumnDefs();
  let [columnsState, SetColumnsState] = useState(selector?initialColsSelector(columnDefs):[])
  let [api, setApi] = useState(undefined)
  
  const onHideColumn = (newColumns:[any]) =>{
    let newState = onChangeColumns(newColumns, columnDefs);
    SetColumnsState(newState)
  }

  useImperativeHandle(
    ref,
    () => ({
        onFilterClear(){
          api && resetFilters(api)
        },
        onExport() {
          exportGrid({ fileName: "Informe_Personas_MenosCincuentaPorc", api: api })
      }
     })
  )

  const updateApi = (api:any) =>{
    setApi(api)
  }

    return (
      <FlexView grow column>
        <DataGrid
        data={data}
        columnDefs={columnDefs}
        columnsState={columnsState}
        menu={menu}
        selector={selector}
        floatingFilter
        fileExportName="Informe_Personas_MenosCincuentaPorc"
        onHideColumn = {onHideColumn}
        updateApi={updateApi}
        />
      </FlexView>
    );
})